"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatadogAdapter = void 0;
var _browserRum = require("@datadog/browser-rum");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
class DatadogAdapter {
  constructor() {
    _defineProperty(this, "enabled", false);
    _defineProperty(this, "initialized", false);
  }
  init(config) {
    this.enabled = config.product_analytics_enabled;
    if (!this.enabled || !config.datadog.application_id || !config.datadog.client_token || this.initialized) {
      return;
    }
    _browserRum.datadogRum.init({
      applicationId: config.datadog.application_id,
      clientToken: config.datadog.client_token,
      site: "datadoghq.com",
      // `site` refers to the Datadog site parameter of your organization see https://docs.datadoghq.com/getting_started/site/
      service: "cedar",
      env: config.env || config.environment,
      sessionSampleRate: config.datadog.session_sample_rate,
      sessionReplaySampleRate: config.datadog.session_replay_sample_rate,
      defaultPrivacyLevel: "mask-user-input",
      compressIntakeRequests: true,
      workerUrl: new URL("/datadog-worker/", window.location.origin).href
    });
    this.initialized = true;
  }
  identifyUser(id) {
    if (!this.enabled) {
      return;
    }
    _browserRum.datadogRum.setUser({
      id
    });
  }
  setUserProperty(key, value) {
    if (!this.enabled) {
      return;
    }
    _browserRum.datadogRum.setUserProperty(key, value);
  }

  // https://docs.datadoghq.com/real_user_monitoring/browser/troubleshooting/#the-rum-browser-sdk-is-initialized
  isInitialized() {
    // @ts-ignore - window.DD_RUM is defined in the Datadog browser SDK
    const context = window.DD_RUM?.getInternalContext();
    if (!context) {
      return false;
    }
    const keysToCheck = ["application_id", "session_id", "view_id"];
    return keysToCheck.every(key => !!context[key]);
  }
  trackEvent(name, properties) {
    if (!this.enabled) {
      return;
    }
    _browserRum.datadogRum.addAction(name, properties);
  }
}
exports.DatadogAdapter = DatadogAdapter;